import { writable } from "svelte/store";

const PollStore = writable([
  {
    id: "dac607e8-b464-46a6-b120-4ce28be5d3d3",
    question: "Apache or Nginx?",
    answerA: "Apache",
    answerB: "Nginx",
    voteA: 12,
    voteB: 4
  },
  {
    id: "70d91d9e-4975-4046-b34c-51c9fc779ba0",
    question: "Python or Javascript?",
    answerA: "Python",
    answerB: "Javascript",
    voteA: 10,
    voteB: 16
  }
]);

export default PollStore;
